export const OTP_STATE_MACHINE_ID = 'otpStateMachine';

export const otpStateMachineStates = {
  RESEND_DISABLE_STATE: 'resendDisableState',
  RESEND_ENABLED_STATE: 'resendEnableState'
};

export const otpStateMachineEvents = {
  RESEND_DISABLE: 'RESEND_DISABLE',
  RESEND_ENABLE: 'RESEND_ENABLE'
};
